<template>
<SideHeader :indexPage="true"/>

  <div style="padding-top: 55px;">
    <div class="section full">
      <img
        src="assets/img/sample/photo/term.jpeg"
        alt="image"
        class="img-fluid"
      />
    </div>
    <div class="section full mt-2">
      <div class="section-title">سوالات متداول</div>

      <div class="accordion" id="accordionExample1">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#accordion1"
            >
              درخواست به راهنمایی دارم چطور با پشتیبانی ارتباط بگیرم؟
            </button>
          </h2>
          <div
            id="accordion1"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample1"
          >
            <div class="accordion-body">
              کارشناسان ما تمام روزهای هفته و به‌صورت 24 ساعته پاسخ گوی سوالات
              شما هستند، کافیست از قسمت پشتیبانی یکی از راه های ارتباط با ما را
              انتخاب و بصورت آنلاین سوال خود را مطرح کنید.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#accordion2"
            >
              اعلام بار در اس بار شامل چه ناوگان‌هایی است؟
            </button>
          </h2>
          <div
            id="accordion2"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample2"
          >
            <div class="accordion-body">
              تمامی ناوگان‌ها با روزانه بیش از 15 هزار بار از سراسر ایران در
              برنامه به رانندگان عزیز اعلام می شود.
            </div>
          </div>
        </div>
        <!-- <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#accordion3"
            >
              چگونه به‌روزرسانی جدید برنامه را انجام دهم؟
            </button>
          </h2>
          <div
            id="accordion3"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample3"
          >
            <div class="accordion-body">
              از طریق کافه‌بازار و مایکت یا مراجعه به سایت رسمی اس بار به
              آدرس
              <br />
              <a href="https://www.iran-tarabar.com">سایت اس بار</a>
            </div>
          </div>
        </div> -->
        
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#accordion5"
            >
              علت مشاهده ی خطای اتصال به اینترنت چیست؟
            </button>
          </h2>
          <div
            id="accordion5"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample5"
          >
            <div class="accordion-body">
              کاربر گرامی خطای اتصال به اینترنت ممکن است به علت آنتن‌دهی ضعیف یا
              عدم دسترسی به اینترنت در موقعیت مکانی شما باشد، لطفاً وضعیت
              اینترنت خود را بررسی و در صورت امکان محدوده ی مکانی خود را تغییر
              دهید.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#accordion6"
            >
              در صورت ثبت اشتباه اطلاعات هویتی در برنامه چگونه اطلاعات خود   را ویرایش
              کنم؟
            </button>
          </h2>
          <div
            id="accordion6"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample6"
          >
            <div class="accordion-body">
              ویرایش اطلاعات توسط کارشناسان ما و پس از ارسال اطلاعات صحیح از
              طریق تیکت یا گفت‌وگوی آنلاین در بخش پشتیبانی امکان‌پذیر است.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <Footer /> -->

</template>
  
<script>
// import Footer from '@/components/footer.vue';
import SideHeader from '@/components/SideHeader.vue';

export default {
  name: "faq",
  components:{
    SideHeader,
    // Footer
  }
};
</script>
  
<style scoped></style>